import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Container, Link, styled } from "@mui/material";
import parse, { domToReact } from "html-react-parser";
import { memo } from "react";
import { msgs } from "./CalculatorL10n";
import { InlineDiv } from "./CalculatorStyled";
const CenterSection = styled("section")({
    textAlign: "center",
});
const parseOptions = {
    replace: (node) => {
        if (node.tagName === "a") {
            return _jsx(Link, { href: node.attribs.href, target: node.attribs.target, children: domToReact(node.children, parseOptions) });
        }
    }
};
const Desc = memo(() => (_jsx("section", { children: parse(msgs[5 /* S.c_wizard_text */], parseOptions) })));
export default memo(({ exit }) => {
    return (_jsxs(Container, { children: [_jsxs(CenterSection, { children: [_jsx("h1", { children: msgs[0 /* S.app_name */] }), _jsx("p", { children: msgs[3 /* S.c_first_start_text_1 */] }), _jsx("p", { children: msgs[4 /* S.c_first_start_text_2 */] }), _jsx("br", {}), _jsx(InlineDiv, { children: _jsx(Button, { onClick: exit, variant: "contained", children: msgs[2 /* S.cpp_wizard_next */] }) })] }), _jsx("br", {}), _jsx("br", {}), _jsx(Desc, {}), _jsxs(CenterSection, { children: [_jsx(InlineDiv, { children: _jsx(Button, { onClick: exit, variant: "contained", children: msgs[2 /* S.cpp_wizard_next */] }) }), _jsx("br", {}), _jsx("br", {})] })] }));
});
